/**
 * Product PhotoSwipe Lightbox
 *
 * Replaces Dawn's built-in product modal for image media when image_zoom == 'lightbox'.
 * Non-image media (video, 3D model) still use the default Dawn modal.
 *
 * Uses capturing-phase click interception to prevent ModalOpener from firing
 * for image media, while leaving non-image media behavior untouched.
 */

(function () {
  'use strict';

  const CLOSE_SVG = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.9793 0.442528C15.1276 0.590813 15.2109 0.791931 15.2109 1.00164C15.2109 1.21134 15.1276 1.41246 14.9793 1.56075L8.82915 7.71094L14.9793 13.8611C15.1276 14.0094 15.2109 14.2105 15.2109 14.4202C15.2109 14.6299 15.1276 14.8311 14.9793 14.9793C14.8311 15.1276 14.6299 15.2109 14.4202 15.2109C14.2105 15.2109 14.0094 15.1276 13.8611 14.9793L7.71094 8.82915L1.56075 14.9793C1.41246 15.1276 1.21134 15.2109 1.00164 15.2109C0.791931 15.2109 0.590813 15.1276 0.442529 14.9793C0.294244 14.8311 0.210938 14.6299 0.210938 14.4202C0.210938 14.2105 0.294244 14.0094 0.442529 13.8611L6.59272 7.71094L0.442529 1.56075C0.294244 1.41246 0.210938 1.21134 0.210938 1.00164C0.210938 0.791931 0.294244 0.590813 0.442529 0.442528C0.590813 0.294243 0.791931 0.210938 1.00164 0.210938C1.21134 0.210938 1.41246 0.294243 1.56075 0.442528L7.71094 6.59272L13.8611 0.442528C14.0094 0.294243 14.2105 0.210938 14.4202 0.210938C14.6299 0.210938 14.8311 0.294243 14.9793 0.442528Z" fill="currentColor" stroke="currentColor" stroke-width="0.421706"></path></svg>`;
  const NEXT_SVG = `<svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.10848 5.78176L1.76833 0.441706C1.64482 0.318097 1.47994 0.25 1.30414 0.25C1.12833 0.25 0.963458 0.318097 0.839947 0.441706L0.446681 0.834873C0.190781 1.09107 0.190781 1.50745 0.446681 1.76326L4.93094 6.24751L0.441705 10.7367C0.318194 10.8604 0.25 11.0251 0.25 11.2008C0.25 11.3767 0.318194 11.5415 0.441705 11.6652L0.83497 12.0583C0.958579 12.1819 1.12336 12.25 1.29916 12.25C1.47497 12.25 1.63984 12.1819 1.76335 12.0583L7.10848 6.71336C7.23229 6.58936 7.30029 6.4238 7.2999 6.24781C7.30029 6.07112 7.23229 5.90566 7.10848 5.78176Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"></path></svg>`;
  const PREV_SVG = `<svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: scaleX(-1)"><path d="M7.10848 5.78176L1.76833 0.441706C1.64482 0.318097 1.47994 0.25 1.30414 0.25C1.12833 0.25 0.963458 0.318097 0.839947 0.441706L0.446681 0.834873C0.190781 1.09107 0.190781 1.50745 0.446681 1.76326L4.93094 6.24751L0.441705 10.7367C0.318194 10.8604 0.25 11.0251 0.25 11.2008C0.25 11.3767 0.318194 11.5415 0.441705 11.6652L0.83497 12.0583C0.958579 12.1819 1.12336 12.25 1.29916 12.25C1.47497 12.25 1.63984 12.1819 1.76335 12.0583L7.10848 6.71336C7.23229 6.58936 7.30029 6.4238 7.2999 6.24781C7.30029 6.07112 7.23229 5.90566 7.10848 5.78176Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"></path></svg>`;

  function initPhotoSwipe(gallery) {
    if (gallery._pswpInitialized) return;
    gallery._pswpInitialized = true;

    // Build data source from image containers
    const containers = gallery.querySelectorAll('.product-media-container.media-type-image[data-pswp-src]');
    if (!containers.length) return;

    const dataSource = [];
    const mediaIdToIndex = new Map();
    const indexToMediaId = new Map();

    containers.forEach((container, i) => {
      dataSource.push({
        src: container.dataset.pswpSrc,
        width: parseInt(container.dataset.pswpWidth, 10),
        height: parseInt(container.dataset.pswpHeight, 10),
      });

      // Find the parent [data-media-id] element
      const mediaItem = container.closest('[data-media-id]');
      if (mediaItem) {
        const mediaId = mediaItem.dataset.mediaId;
        mediaIdToIndex.set(mediaId, i);
        indexToMediaId.set(i, mediaId);
      }
    });

    if (!dataSource.length) return;

    const lightbox = new window.PhotoSwipeLightbox({
      dataSource: dataSource,
      pswpModule: window.PhotoSwipe,
      bgOpacity: 1,
      // Disable default UI buttons (we register custom ones)
      closeSVG: '',
      arrowPrevSVG: '',
      arrowNextSVG: '',
      close: false,
      arrowPrev: false,
      arrowNext: false,
      counter: false,
      zoom: false,
      preloader: false,
      pinchToClose: true,
      closeOnVerticalDrag: true,
      padding: { top: 0, bottom: 0, left: 0, right: 0 },
    });

    // Register custom UI buttons (order: prev=1, close=2, next=3 for bottom-center row)
    lightbox.on('uiRegister', function () {
      // Previous button
      lightbox.pswp.ui.registerElement({
        name: 'custom-prev',
        order: 1,
        isButton: true,
        html: PREV_SVG,
        onClick: (event, el, pswp) => {
          pswp.prev();
        },
        onInit: (el) => {
          el.classList.add('pswp__button--custom', 'pswp__button--custom-prev');
          el.setAttribute('aria-label', 'Previous image');
        },
      });

      // Close button (center)
      lightbox.pswp.ui.registerElement({
        name: 'custom-close',
        order: 2,
        isButton: true,
        html: CLOSE_SVG,
        onClick: (event, el, pswp) => {
          pswp.close();
        },
        onInit: (el) => {
          el.classList.add('pswp__button--custom', 'pswp__button--custom-close');
          el.setAttribute('aria-label', 'Close lightbox');
        },
      });

      // Next button
      lightbox.pswp.ui.registerElement({
        name: 'custom-next',
        order: 3,
        isButton: true,
        html: NEXT_SVG,
        onClick: (event, el, pswp) => {
          pswp.next();
        },
        onInit: (el) => {
          el.classList.add('pswp__button--custom', 'pswp__button--custom-next');
          el.setAttribute('aria-label', 'Next image');
        },
      });
    });

    // Build pswp index → swiper slide index mapping at init time
    const pswpToSwiperIndex = new Map();
    containers.forEach((container, pswpIdx) => {
      const slide = container.closest('.swiper-slide');
      if (slide) {
        const allSlides = Array.from(slide.parentElement.children);
        pswpToSwiperIndex.set(pswpIdx, allSlides.indexOf(slide));
      }
    });

    // Sync swiper during lightbox navigation (speed 0 = no CSS transition,
    // transform is set synchronously even behind the overlay)
    lightbox.on('change', () => {
      if (!lightbox.pswp) return;
      const pswpIndex = lightbox.pswp.currIndex;

      if (gallery.swiper) {
        const swiperIndex = pswpToSwiperIndex.get(pswpIndex);
        if (swiperIndex !== undefined) {
          gallery.swiper.slideTo(swiperIndex, 0, false);
        }
      } else {
        const mediaId = indexToMediaId.get(pswpIndex);
        if (mediaId && typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(mediaId, false);
        }
      }
    });

    // Backup sync after lightbox fully closes — catches any edge cases
    // where the change handler's slideTo didn't apply visually
    lightbox.on('destroy', () => {
      if (!gallery.swiper) return;
      const swiperIndex = pswpToSwiperIndex.get(lightbox.pswp?.currIndex ?? 0);
      if (swiperIndex === undefined) return;
      // Force re-sync regardless of activeIndex (it may match but visual may not)
      gallery.swiper.slideTo(swiperIndex, 0);
    });

    // Zoom-from-thumbnail: use the swiper's active slide img.
    // After the change handler's slideTo(index, 0), activeIndex and transform
    // are updated. getBoundingClientRect() forces layout recalc and returns
    // the correct position even if the element hasn't been painted yet.
    lightbox.addFilter('thumbEl', (thumbEl, data, index) => {
      if (gallery.swiper) {
        const activeSlide = gallery.swiper.slides[gallery.swiper.activeIndex];
        if (activeSlide) {
          const img = activeSlide.querySelector('img');
          if (img) return img;
        }
      }
      const container = containers[index];
      if (container) {
        const img = container.querySelector('img');
        if (img) return img;
      }
      return thumbEl;
    });

    // Show the current thumbnail as placeholder while full-res loads
    lightbox.addFilter('placeholderSrc', (placeholderSrc, slideData) => {
      const container = containers[slideData.index];
      if (container) {
        const img = container.querySelector('img');
        if (img) return img.src;
      }
      return placeholderSrc;
    });

    lightbox.init();

    // Drag detection — prevent lightbox from opening after a swiper drag-release
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    const DRAG_THRESHOLD = 5;

    gallery.addEventListener('pointerdown', (e) => {
      isDragging = false;
      startX = e.clientX;
      startY = e.clientY;
    }, true);

    gallery.addEventListener('pointermove', (e) => {
      if (Math.abs(e.clientX - startX) > DRAG_THRESHOLD || Math.abs(e.clientY - startY) > DRAG_THRESHOLD) {
        isDragging = true;
      }
    }, true);

    // Click interception (capturing phase) - intercept image clicks before ModalOpener
    gallery.addEventListener(
      'click',
      (e) => {
        // Look for zoom button or the modal-opener area for images
        const trigger = e.target.closest('.product__modal-opener--image');
        if (!trigger) return;

        const container = trigger.closest('.product-media-container');
        if (!container || !container.classList.contains('media-type-image')) return;

        e.stopPropagation();
        e.preventDefault();

        // Skip if the click came from a drag/swipe release
        if (isDragging) {
          isDragging = false;
          return;
        }

        // Find which image index to open
        const mediaItem = trigger.closest('[data-media-id]');
        const mediaId = mediaItem?.dataset.mediaId;
        const index = mediaId ? (mediaIdToIndex.get(mediaId) ?? 0) : 0;

        lightbox.loadAndOpen(index);
      },
      true
    ); // Capturing phase

    // Store reference for cleanup
    gallery._pswpLightbox = lightbox;
  }

  function initAllGalleries() {
    document.querySelectorAll('media-gallery[data-image-zoom="lightbox"]').forEach(initPhotoSwipe);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGalleries);
  } else {
    initAllGalleries();
  }

  // Re-initialize when sections reload (theme editor + AJAX section rendering)
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target;
    const galleries = section.querySelectorAll
      ? section.querySelectorAll('media-gallery[data-image-zoom="lightbox"]')
      : [];
    galleries.forEach(initPhotoSwipe);
  });
})();
